module.exports = __webpack_public_path__ + "img/sp_1.8177f724.png";